import { useStore } from '@tanstack/react-form';
import { useFormContext } from '.';
import { Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import commonMessages from '~/containers/App/messages';

type SubmitButtonProps = {
  children?: React.ReactNode;
  loadingText?: React.ReactNode;
};

export const SubmitButton = (props: SubmitButtonProps) => {
  const form = useFormContext();
  const isSubmitting = useStore(form.store, (state) => state.isSubmitting);
  return (
    <Button
      variant="contained"
      size="large"
      type="submit"
      disabled={isSubmitting}
    >
      {isSubmitting
        ? props.loadingText || <FormattedMessage {...commonMessages.loading} />
        : props.children || <FormattedMessage {...commonMessages.save} />}
    </Button>
  );
};
